











import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import VerificationsForm from '@/UI/Auction/Verifications/VerificationsForm.vue'
import { VerificationData } from '@/Infrastructure/Store/Auction/VerificationData'
import { PersonalData as VuexPersonalData } from '@/Infrastructure/Store/Auction/PersonalData'

const auctionStore = namespace('auction')
const procedureStore = namespace('procedure')

@Component({
  components: { VerificationsForm }
})

export default class VerificationsLayout extends Vue {
  arraIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  veriSelecteds: VerificationData[] = []

  @procedureStore.Getter
  currentProcedureId!: string

  @auctionStore.Getter
  public personalData!: VuexPersonalData

  @auctionStore.Getter
  public verificationData!: VerificationData[]

  @auctionStore.Action
  public setVerifications!: (verificationsData: VerificationData[]) => void

  public mounted (): void {
    this.veriSelecteds = this.verificationData
    this.$emit('formValid', true)
  }

  public onUpdateVerificationData (item: VerificationData): void {
    let updated = false
    const verifications = [...this.veriSelecteds]
    verifications.forEach(doc => {
      if (doc.id === item.id) {
        doc.fileName = item.fileName
        doc.opposeToQuery = item.opposeToQuery
        updated = true
      }
    })

    if (!updated) {
      verifications.push(item)
    }

    this.veriSelecteds = verifications
    this.setVerifications(verifications)
  }

  public onVerificationFailed (id: number): void {
    if (id != null && this.veriSelecteds.length > 0) {
      const index = this.veriSelecteds.map(e => { return e.id }).indexOf(id)
      if (index > -1) {
        this.veriSelecteds.splice(index, 1)
      }
    }

    this.setVerifications(this.veriSelecteds)
  }
}
